export default __webpack_public_path__ + "static/Денежный поток 303+404_7-55f51b1286ad3960c330333ca49f909f.jpg";